<template>
  <div class="coupon main m-box9">

    <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      class="page_scroll">
      <!--  @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" -->
      <div class="m-ticket2" v-for="(item,index) in couponInfo" :key="index">
        <div class="ticket ticket2">
          <a href="javascript:;" class="a-tick">
            <div class="time">已过期</div>
            <span>优惠券</span>
            <div class="num">
              <i>+</i>{{item.money}}
            </div>
            <em></em>
            <p>使用期限：{{item.start_time}} 至 {{item.over_time}}</p>
            <p>满{{item.number}}可用</p>
          </a>
          <!-- :class=" item.isGet ? 'active' : ''"  {{item.isGet ? '立即领取' : '已领取'}}-->
          <a href="javascript:;" class="a-use" :class=" item.status == 1 ? 'active' : ''"
             @click.prevent="giveCoupon(item)">{{item.status == 1 ? '已领取' : '立即领取'}}</a>
        </div>
      </div>
      <!-- </leftSlider> -->
      <!-- <div class="ticket on">
          <div class="time">已过期</div>
          <span>优惠券</span>
          <div class="num">
              <i>+</i>20.00
          </div>
          <em></em>
          <p>使用期限： 2018-10-20 至 2019-12-12</p>
          <p>满200可用</p>
      </div> -->
      <!-- </div> -->
    </cube-scroll>
  </div>
</template>
<script>
   import moment from 'moment'

   export default {
      name: 'Getcoupon',
      data() {
         return {
            user_id: localStorage.getItem('user_id'),
            couponInfo: [],
            pageNum: 1,
            allPage: null,
            items: [],
            //   isGet: false,
            options: {
               //   pullUpLoad: {
               //     threshold: 60,
               //     txt: {
               //       more: '加载更多',
               //       // noMore: '没有更多了'
               //     }
               //   },
               //   pullDownRefresh: {
               //     threshold: 60,
               //     // stop:,
               //     // stopTime:,
               //     txt: '刷新成功'
               //   },
            },
         }
      },
      created() {
         this.$loading.show()
         this.loadPage(1, 1)
      },
      methods: {
         loadPage() {
            // pageNum, type
            let _this = this
            this.$http.api.getCoupon({
               // page: pageNum,
               // size: 10,
               user_id: this.user_id
            }).then(result => {
               this.$loading.hide()
               this.couponInfo = [...result]
               //  _this.allpage = Math.ceil(result.total/10)
               //   let data = [...result.rows]
               //   if (type === 1) {
               //     _this.couponInfo = [...data]
               //     _this.$refs.scroll.forceUpdate()
               //     _this.pageNum = 2
               //     // _this.$refs.scroll.forceUpdate()
               //   } else {
               //     if (data.length > 0 && _this.pageNum <=  _this.allpage) {
               //        _this.couponInfo = _this.couponInfo.concat(data)
               //       _this.pageNum = _this.pageNum + 1
               //        _this.$refs.scroll.forceUpdate()
               //     }
               //   }
               _this.couponInfo = _this.couponInfo.map(item => {
                  return Object.assign({}, item, {    //时间格式化
                     start_time: moment(item.start_time).format('YYYY-MM-DD'),
                     over_time: moment(item.over_time).format('YYYY-MM-DD')
                  });
               });
            })
            //   if( _this.pageNum > _this.allpage){
            //       setTimeout(function () {
            //         _this.$refs.scroll.forceUpdate()
            //       }, 300)
            //   }
         },
         //  onPullingDown () {
         //     // this.isLoading = false
         //     this.loadPage(1, 1)
         //   },
         //   onPullingUp () {
         //     let _this = this
         //     // _this.isLoading = false
         //     setTimeout(function () {
         //       _this.loadPage(_this.pageNum, 2)
         //     }, 800)
         //   },
         giveCoupon(item) {
            if (item.status == 1) {
               const toast = this.$createToast({
                  txt: '您已领过该优惠券哦~',
                  type: 'txt'
               }).show()
               return
            }
            //   if(typeof item.isGet =='undefined'){
            this.$http.api.giveCoupon({
               user_id: this.user_id,
               coupons_id: item.coupons_id
            }).then(result => {
               //   this.$set(item,"isGet",true);
               const toast = this.$createToast({
                  txt: '领取成功',
                  type: 'txt'
               }).show()
               this.loadPage()
            })
            //  }
         }
      }
   }
</script>
<style lang="less" scoped>
  .page_scroll {
    bottom: 20px;
    top: 40px;
  }

  .coupon {
    height: 100%;
    background: #60b0e3;
    background: url('../assets/images/j-p5.jpg') no-repeat center center;
    background-size: 100% 100%;

    .m-ticket2 {
      margin-bottom: 50px;

      a.a-use {
        background: #fff;
        right: 3px;
      }

      a.a-use.active {
        background: #ccc;
      }
    }
  }

  .ticket2::after, .ticket2::before {
    background: #60b0e3;
  }
</style>


